import React from 'react';
import { Card, CardContent } from '../../../components/ui/card';
import { Label } from '../../../components/ui/label';

/**
 * Step 2 — Subcategory (format) grid for the selected product.
 * Click a card to select the format and auto-advance to step 3.
 */
export const Step2Format = ({ productData, selectedProduct, selectedFormat, setSelectedFormat, setStep }) => {
  const selectedCategory = productData.categories.find((cat) => cat.id === selectedProduct);
  const subcategories = selectedCategory?.subcategories || [];

  return (
    <div>
      <Label className="text-lg font-semibold mb-4 block">Choose a Format</Label>
      <div className="grid grid-cols-2 md:grid-cols-3 gap-6">
        {subcategories.map((subcat) => (
          <Card
            key={subcat.id}
            data-testid={`format-card-${subcat.id}`}
            className={`cursor-pointer transition-all duration-300 ease-out hover:shadow-2xl hover:-translate-y-2 group overflow-hidden relative ${
              selectedFormat === subcat.id
                ? 'border-[#6FBF73] border-2 bg-green-50 shadow-lg animate-pulse-ring'
                : 'border-gray-200 hover:border-[#6FBF73] shadow-md'
            }`}
            onClick={() => {
              setSelectedFormat(subcat.id);
              setStep(3);
            }}
          >
            <CardContent className="p-5">
              {subcat.image ? (
                <div className="overflow-hidden rounded-lg bg-gradient-to-br from-green-50 to-white">
                  <img
                    src={subcat.image}
                    alt={subcat.name}
                    className="w-full h-auto object-contain rounded transition-all duration-500 ease-out group-hover:scale-110"
                  />
                </div>
              ) : (
                <div className="text-5xl mb-2 transition-transform duration-300 group-hover:scale-125 group-hover:rotate-12">📦</div>
              )}
              <div className="absolute inset-0 bg-gradient-to-t from-[#6FBF73]/10 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 pointer-events-none" />
            </CardContent>
          </Card>
        ))}
      </div>
    </div>
  );
};
